/* eslint-disable max-len */
const fr = {
  nav: {
    archives: "Archives",
    apropos: "À propos",
    vestiaire: "Vestiaire",
    journal: "Journal",
    contact: "Contact",
    menu: "Menu",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    openCart: "Ouvrir le panier",
    cart: "Panier",
  },

  footer: {
    rights: "Tous droits réservés.",
    legal: "Mentions légales",
  },

  cart: {
    title: "Panier",
    empty: "Votre panier est silencieux.",
    emptySub: "Choisissez une pièce du vestiaire ou écrivez-nous pour une commande personnalisée.",
    discoverCta: "Voir le vestiaire",
    sizeUnique: "Taille unique",
    summary: "Sous-total",
    note: "Livraison et taxes calculées au paiement. Confection à la commande sous 3 à 4 semaines.",
    checkout: "Valider la commande",
    redirecting: "Redirection…",
    contactLink: "Écrire à l'atelier",
    remove: "Retirer",
  },

  product: {
    breadcrumbBack: "Vestiaire",
    sizeLabel: "Taille",
    addToCart: "Ajouter au panier",
    soonCta: "Être informé",
    soonNote: "Saison 01 — bientôt en atelier.",
    onOrder: "Commander cette pièce",
    onOrderNote: "Disponible sur commande.",
    soldOut: "Épuisée",
    statusSoon: "Soon",
    statusLabel: "Statut",
    statusAvailable: "Disponible",
    statusOnOrder: "Sur commande",
    statusSoldOut: "Épuisée",
    accordionStory: "L'histoire",
    accordionMaterials: "Entretien",
    accordionShipping: "Livraison & retours",
    materialsText: "Lavage à la main ou pressing recommandé. Repassage doux à l'envers. Pour préserver la matière, éviter l'exposition prolongée au soleil et privilégier un séchage à plat.",
    shippingText: "Pulaar livre dans le monde entier via DHL Express. France offerte, Europe 15 €, International 25 €. Délai estimé 2 à 3 semaines. Retours possibles sous 14 jours sur les pièces non personnalisées.",
    fabricationNote: "Confection à la commande sous 3 à 4 semaines.",
    contactLink: "Écrire à l'atelier",
  },

  vestiaire: {
    eyebrow: "— Vestiaire",
    title: "Pièces, archives, présences.",
    subtitle: "Chaque vêtement Pulaar est numéroté, daté, et archivé. Une pièce, une mémoire, une trace.",
    filterAll: "Toutes",
    filterCategory: {
      tops: "Hauts",
      shirts: "Chemises",
      jackets: "Vestes",
      pants: "Pantalons",
    },
    counter: "{{count}} pièces",
    empty: "Aucune pièce dans cette catégorie pour le moment.",
  },

  checkout: {
    summaryTitle: "Votre pièce",
    origin: "Origine",
    fabrication: "Fabrication",
    size: "Taille",
    quantity: "Quantité",
    total: "Total",
    paymentTitle: "Paiement sécurisé",
    paymentSubtitle: "Stripe — carte bancaire",
    backToVestiaire: "Retour au vestiaire",
    success: "Paiement confirmé",
    successSub: "Votre commande a bien été enregistrée. Un email de confirmation vous a été envoyé.",
    successCta: "Continuer la visite",
    error: "Une erreur est survenue lors de la création du paiement.",
    pieceLabel: "— Votre pièce",
    paymentNote: "Paiement sécurisé par Stripe. Pulaar livre dans l'Espace Européen, Royaume-Uni, États-Unis, Canada, Japon et Sénégal.",
    loading: "Chargement du paiement…",
    missingKey: "Clé publique Stripe manquante côté serveur.",
    checkingPayment: "Vérification du paiement…",
    paidTitle: "Paiement confirmé.",
    paidSub: "Merci. Nous préparons votre pièce et vous écrivons à l'expédition. Une confirmation vient d'être envoyée à votre email.",
    amount: "Montant",
    backToVestiaire: "Retour au vestiaire",
    pendingTitle: "Vérification en cours côté banque.",
    pendingSub: "Si le paiement est confirmé, vous recevrez un email. Pour toute question, écrivez à info@pulaar.co.",
    backHome: "Retour à l'accueil",
    expiredTitle: "Session expirée.",
    expiredSub: "Vous pouvez relancer la commande depuis le vestiaire.",
    noSession: "Aucune session trouvée.",
  },

  contact: {
    eyebrow: "— Atelier",
    title: "Écrire à",
    titleEm: "Pulaar.",
    subtitle: "Pour une disponibilité, une commande sur mesure, une collaboration ou une question : nous lisons chaque message.",
    name: "Nom",
    email: "Email",
    kind: "Sujet",
    kinds: {
      disponibilite: "Disponibilité d'une pièce",
      commande: "Commande spéciale",
      collaboration: "Collaboration",
    },
    message: "Message",
    submit: "Envoyer",
    sending: "Envoi…",
    sent: "Message envoyé.",
    sentSub: "Nous revenons vers vous très bientôt.",
    error: "Une erreur est survenue. Réessayez ou écrivez-nous à info@pulaar.co.",
    cities: "Dakar · Paris",
    instagram: "Instagram",
    asideTitle: "L'atelier répond.",
    asideText: "Nous lisons chaque message et répondons sous 48 h.",
  },

  specialOrder: {
    title: "Être informé",
    subtitle: "Laissez-nous vos coordonnées : nous vous écrirons dès que cette pièce sera disponible.",
    name: "Nom",
    email: "Email",
    phone: "Téléphone (facultatif)",
    message: "Message (facultatif)",
    submit: "M'inscrire",
    sending: "Envoi…",
    sent: "Bien noté. Nous reviendrons vers vous.",
    close: "Fermer",
  },

  archives: {
    eyebrow: "— Archives",
    titleA: "Récits, ",
    titleEm: "inspirations,",
    titleC: " archives.",
    seeAll: "Les chapitres",
    intro: "Maabube, Dammeel, Ceddo. Trois figures, trois gestes, trois manières d'habiter l'histoire. Pulaar ne construit pas seulement un vestiaire : la marque compose des chapitres, des matières, des images et des objets en circulation lente.",
    chapter: "Chapitre · {{symbol}}",
    readStory: "Lire le récit",
    explore: "Explorer ce chapitre",
    atelierEyebrow: "— Atelier",
    atelierTitleA: "La main, la ",
    atelierTitleEm: "matière",
    atelierTitleC: ", le temps.",
    atelierBadge: "— Atelier · Geste",
    citiesBadge: "Dakar · Paris",
    troisFiguresEyebrow: "— Trois figures",
    troisFiguresTitle: "Maabube. Dammeel. Ceddo.",
    troisFiguresIntro: "Trois figures peules — l'artisan qui transmet, le noble qui porte, le guerrier qui marche. Trois manières d'habiter le monde. Trois chapitres.",
    blocks: {
      matieres: {
        title: "Matières",
        text: "Cotons tissés, toiles anciennes, laines, cuirs et matières choisies pour leur main, leur tenue et leur capacité à vieillir avec dignité.",
      },
      "savoir-faire": {
        title: "Savoir-faire",
        text: "Un dialogue entre tissage, patronage, coupe et finitions. Chaque détail garde la trace du geste.",
      },
      "petites-series": {
        title: "Petites séries",
        text: "Quelques pièces seulement par modèle. La rareté ne vient pas d'un effet, mais du temps nécessaire à chaque pièce.",
      },
      commande: {
        title: "Commande",
        text: "Certaines pièces peuvent être réalisées à la commande après échange avec l'atelier, selon la matière disponible.",
      },
      fabrication: {
        title: "Fabrication",
        text: "Confection entre Dakar et Paris. Deux ateliers, une même exigence : la présence durable du vêtement.",
      },
    },
    transmissionEyebrow: "— Transmission",
    transmissionTitleA: "Numéroté, signé, ",
    transmissionTitleEm: "réparable",
    transmissionTitleC: ".",
    transmissionText: "Chaque pièce porte une trace : un numéro, une main, une histoire. Avec le temps, elle peut être reprise, ajustée ou réparée. Pulaar préfère la continuité au remplacement.",
    transmissionCta: "Parler avec l'atelier",
  },

  apropos: {
    eyebrow: "— À propos",
    titleA: "",
    titleEm: "Pulaar",
    titleC: ".",
    s1Label: "01 — Pulaar",
    s1p1: "Pulaar est un vestiaire contemporain né entre Paris et Dakar.",
    s1p2: "La marque puise dans l'histoire, les cultures et les savoir-faire de l'Afrique de l'Ouest pour construire son propre langage vestimentaire.",
    s1p3: "Chaque pièce est pensée comme une interprétation plutôt qu'une reproduction : une matière, une coupe, un détail ou un geste peuvent porter la trace d'une histoire sans jamais chercher à la reconstituer.",
    s2Label: "02 — Le nom",
    s2p1: "Pulaar est le nom d'une langue parlée par les Haalpulaar, populations historiquement présentes à travers plusieurs territoires d'Afrique de l'Ouest.",
    s2p2: "Ce nom porte naturellement les notions de mouvement, de territoire et de transmission.",
    s2p3: "Pulaar commence au Sénégal, mais son regard dépasse les frontières contemporaines.",
    s3Label: "03 — Le vestiaire",
    s3p1: "Pulaar ne pense pas ses vêtements comme des collections destinées à disparaître au rythme des saisons.",
    s3p2: "Les silhouettes sont développées pour durer, revenir et évoluer. Une même pièce peut réapparaître dans une autre matière, être produite en petite quantité ou réalisée selon la disponibilité d'un tissu.",
    phraseA: "Le vêtement reste.",
    phraseB: "La matière peut changer.",
    blocks: {
      matieres: {
        title: "Matières",
        text: "Cotons tissés, denim, toiles anciennes et matières sélectionnées pour leur texture, leur tenue et la manière dont elles évoluent avec le temps.",
      },
      fabrication: {
        title: "Fabrication",
        text: "Développement et confection entre Paris et Dakar, auprès d'ateliers et de savoir-faire choisis selon les besoins de chaque pièce.",
      },
      rythme: {
        title: "Rythme",
        text: "Produites en petites séries ou à la commande, certaines pièces peuvent revenir dans de nouvelles matières plutôt que d'être remplacées par une nouvelle collection.",
      },
    },
  },

  transmissionPage: {
    eyebrow: "— Transmission",
    titleA: "Les mains, ",
    titleEm: "les gestes",
    titleC: ".",
    intro: "Derrière chaque matière, chaque geste et chaque vêtement se trouvent des personnes. Pulaar documente celles et ceux dont les savoir-faire participent à son histoire.",
  },

  home: {
    heroEyebrow: "— Pulaar · Saison 01",
    heritage: "Héritage",
    heritageEm: "en mouvement.",
    troisEyebrow: "— Archives",
    troisTitleA: "Trois ",
    troisTitleEm: "chapitres",
    troisTitleC: ".",
    troisDesc: "Maabube, Dammeel, Ceddo. Trois figures, trois gestes, trois manières d'habiter l'histoire — pas des collections, des chapitres.",
    vestiaireEyebrow: "— Vestiaire",
    vestiaireTitleA: "Pièces à ",
    vestiaireTitleEm: "commander",
    vestiaireTitleC: ".",
    seeAll: "Tout le vestiaire",
    chapter: "Chapitre · {{symbol}}",
    explore: "Explorer ce chapitre",
    atelierEyebrow: "— Atelier",
    atelierTaglineA: "Matières choisies, gestes lents, ",
    atelierTaglineEm: "petites séries",
    atelierTaglineC: ".",
    exploreArchives: "Explorer les archives",
  },

  mondes: {
    maabube: {
      subtitle: "La main qui transmet.",
      teaser: "Le Maabo préserve les savoirs par la main. Son art transmet une mémoire vivante : celle du geste, du tissage et de la matière qui traverse le temps.",
      quote: "Le marteau du Maabube frappe avec sagesse, car chaque coup scelle l'histoire et façonne l'avenir.",
      storyTitle: "Le Maître Tisserand : Demba Maabu",
      story: [
        "Dans les terres du Fouta, vivait Demba Maabu, un tisserand aux mains magiques. Les Maabube étaient des artisans sacrés, et leurs étoffes portaient des histoires tissées dans les fils.",
        "Demba répondit au roi : « Donnez-moi le temps, et je vous offrirai un tissu qui parle. » Pendant des mois, il travailla en silence, parlant aux esprits et écoutant le murmure des ancêtres.",
        "Quand l'étoffe fut terminée, elle brillait comme l'or et portait les motifs d'un peuple. « Mon art n'est pas à vendre. Il vient de mes ancêtres, et c'est pour eux que je tisse », dit-il.",
        "Les Maabube nous montrent que l'artisanat est l'âme d'une civilisation.",
      ],
    },
    dammeel: {
      subtitle: "L'allure comme héritage.",
      teaser: "Dammeel évoque une noblesse sans démonstration. Une présence, une tenue, une manière d'entrer dans l'espace. Le vêtement devient calme, autorité et élégance silencieuse.",
      quote: "Un chef digne n'est pas seulement couronné, il porte le poids et la sagesse de son peuple.",
      storyTitle: "Le Roi Humble : Kumba Ndoffène Mbodj",
      story: [
        "Au cœur du Kajoor, un Dammeel nommé Kumba Ndoffène Mbodj aimait son peuple plus que tout. Plutôt que de rester dans son palais, il parcourait les villages déguisé en simple voyageur.",
        "Un fermier dit : « Comment le roi peut-il comprendre nos souffrances, lui qui ne connaît pas la sueur du travail ? » Touché, Kumba retourna dans les champs et passa la journée à labourer sous le soleil brûlant.",
        "Quand il révéla son identité, le fermier tomba à genoux. « Un bon roi doit ressentir les souffrances de son peuple pour le servir avec justice », dit-il.",
        "Les Dammeel nous rappellent que la vraie grandeur d'un roi est son humilité.",
      ],
    },
    ceddo: {
      subtitle: "Le corps debout.",
      teaser: "Ceddo porte l'idée de résistance, de protection et de mouvement. Ce chapitre explore des silhouettes plus franches : vêtements de passage, de route, de mémoire et de tenue intérieure.",
      quote: "Le Ceddo tient sa lance avec fierté, mais c'est le courage qui donne le véritable poids à son arme.",
      storyTitle: "Le Guerrier et son Destin : Mbañik Ndongo",
      story: [
        "Dans le royaume du Kajoor, un jeune Ceddo nommé Mbañik Ndongo était connu pour son courage et son sens de l'honneur. Mais Mbañik était différent : il n'était pas seulement fort, il avait l'esprit d'un stratège.",
        "Quand une armée ennemie menaça le royaume, il se leva : « Donnez-moi vos hommes, et je protégerai notre terre comme un lion protège sa tanière. » Avec une poignée de guerriers, il vainquit l'ennemi par la ruse.",
        "Quand le Dammeel mourut sans héritier, les sages dirent : « Cet homme, bien qu'il ne soit pas noble, a le cœur d'un roi. » Mbañik devint Damel, le premier Tiedo à porter la couronne.",
        "Les Ceddo nous enseignent le courage et le sacrifice.",
      ],
    },
  },

  mondeDetail: {
    photoCredit: "Photographie",
    daCredit: "Creative director",
    citationEyebrow: "— Citation peule",
    storyEyebrow: "— Récit",
    galleryEyebrow: "— Galerie éditoriale",
    backToArchives: "Retour aux archives",
    nextChapter: "Chapitre suivant",
    prevChapter: "Chapitre précédent",
  },

  atelierBlocks: [
    {
      eyebrow: "— Geste",
      title: "Le tissage prend le temps de la main.",
      body: "Chaque trame est posée, vérifiée, ajustée. Aucune machine ne reproduit l'attention que le tisserand met à équilibrer un motif. Le travail garde la mémoire des doigts qui l'ont fait.",
    },
    {
      eyebrow: "— Matière",
      title: "Coton brut, denim japonais, indigo véritable.",
      body: "Pulaar choisit ses étoffes pour leur poids, leur grain, leur capacité à vieillir avec dignité. Une pièce doit gagner en présence, pas en perdre.",
    },
    {
      eyebrow: "— Temps",
      title: "Une pièce, des semaines de fabrication.",
      body: "Du croquis à l'envoi : esquisse, prototypage, tissage, coupe, montage, finitions. Chaque étape porte une signature, chaque signature un nom.",
    },
  ],
};

export default fr;
